<template>
    <div class="master-template-text-filter">
        <div class="master-templates-sort-by__label">Search:</div>
        <Input v-model="value" search clearable />
    </div>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { deepClone } from "@/utils";
import { FilterType, MasterTemplateLibraryAction } from "@/store/modules/masterTemplateLibrary";

export default {
    name: "MasterTemplateTextFilter",

    props: {
        campaignMasterTemplateIds: {
            type: Array as PropType<string[]>,
            default() {
                return [];
            }
        }
    },

    computed: {
        filterValues() {
            return this.$store.state.masterTemplateLibrary.filters.filter(filter => filter.type === FilterType.Text);
        },

        value: {
            get() {
                if (this.filterValues.length) {
                    const filterValuesCopy = deepClone(this.filterValues);

                    return filterValuesCopy.pop()?.values;
                }

                return "";
            },

            set(newValue: string) {
                this.$store.dispatch(MasterTemplateLibraryAction.UpdateTextFilter, {
                    values: newValue
                });
            }
        }
    },

    beforeUnmount() {
        this.value = "";
    }
};
</script>

<style lang="scss">
@use "@style/variables" as *;

.master-template-text-filter {
    display: flex;
    margin-right: $spacing;
    justify-content: space-between;
    align-items: center;
    width: 155px;
    flex: 0 0 155px;
    margin-right: $spacing;
}

.master-template-text-filter__label {
    white-space: nowrap;
    display: flex;
    margin-right: $spacing-smaller;
}
</style>
